import { createApp, defineAsyncComponent } from 'vue';
import { i18n } from '../../setup/i18n';

export default function initGatedContentForm() {
    const app = createApp({});
    app.use(i18n)
        .component(
            'GatedContentForm',
            defineAsyncComponent(() => import('./GatedContentForm.vue'))
        )
        .mount('#app-gated-content-form');
}
